import { render, staticRenderFns } from "./EtfPriceChart.vue?vue&type=template&id=9fc42656&scoped=true"
import script from "./EtfPriceChart.vue?vue&type=script&lang=js"
export * from "./EtfPriceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc42656",
  null
  
)

export default component.exports